<template>
    <v-dialog v-model="dialog" max-width="400">
        <template v-slot:activator="{ on }">
            <v-btn text style="text-transform: none;" small v-on="on">
                <v-icon :small="small" :class="color">{{icons.plus}}</v-icon>
                <v-icon :small="small" :class="color">{{icons.group}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="font-weight-light">Add to Group</v-card-title>
            <v-card-text>
                <GroupList rounded @click="AddToGroup($event,'add')" />
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">
                    cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import GroupList from "@/components/groups/GroupList";

  export default {
    props:['keystoadd','small','color'],
    name: "AddToGroup",
    components: {GroupList},
    data() {
      return {
        dialog: false
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    watch:{
      dialog(n){
        if(n){

        }
      }
    },
    methods: {
      ...mapActions(['get', 'post']),
      Close() {
        this.dialog = false
      },
      async AddToGroup(e,action){
        console.log(e,'ffff')
        let rsp = await this.post({
          path:'api/profilesv2/addtogroup',
          body:{
            groupid:e.id,
            keystoadd: this.keystoadd,
            action:action
          }})
        this.dialog=false
        this.$emit('done',rsp)
      }
    }
  }
</script>

<style scoped>

</style>